import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import "../../../assets/css/page/ResizableGrid.scss";
import styles from "../../../assets/MUIStyles/dynamicTableStyles";
import { PAGE_SIZE_50 } from "./Common";
import { leadDataStyles } from "../../../assets/MUIStyles/leadDataStyle";

const ResizableGrid = ({ columns, allRows, pageIndex, setPageIndex }) => {
  return (
    <>
      <Box
        className="custom-grid-container"
        sx={{ height: 500, width: "100%" }}
      >
        <AgGridReact
          columnDefs={columns}
          rowData={allRows}
          defaultColDef={{
            resizable: true,
            minWidth: 100,
            cellStyle: { color: "#333333", fontSize: 13, fontWeight: 500 },
          }}
          suppressColumnVirtualisation={true}
          rowHeight={120}
          headerHeight={56}
          getRowStyle={(params) => {
            if (params?.data?.doNotContact) {
              return { backgroundColor: "#F8D7DA" };
            }
            return;
          }}
        />
      </Box>

      <Stack direction="row" sx={styles.bottomContainer}>
        <Box sx={leadDataStyles.paginationCount}>
          <Typography className="font-12-500">Total</Typography>
          <Typography
            component="span"
            sx={leadDataStyles.paginationCountContainer}
          >
            {`${allRows.length} row(s)`}
          </Typography>
        </Box>

        <Box
          className="flex-only"
          sx={{
            gap: 3,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setPageIndex((prev) => Math.max(prev - 1, 1))}
            disabled={pageIndex === 1}
            sx={styles.paginationButtons}
          >
            Previous
          </Button>
          <Button
            variant="outlined"
            onClick={() =>
              setPageIndex((prev) => Math.min(prev + 1, allRows?.length))
            }
            disabled={allRows?.length < PAGE_SIZE_50}
            sx={styles.paginationButtons}
          >
            Next
          </Button>
        </Box>
      </Stack>
    </>
  );
};

export default ResizableGrid;
